import List2x2 from './List2x2.vue';

export { List2x2 };
export default List2x2;
